import { Component, ElementRef, ViewEncapsulation } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { DialogPanelComponentContent } from "@toro/common/shared/models/dialogs/DialogPanelComponentContent";

@Component({
  selector: 'hub-workspace-checkout-error-panel',
  templateUrl: './checkout-error-panel.component.html',
  styleUrls: ['./checkout-error-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CheckoutErrorPanelComponent extends DialogPanelComponentContent {
  constructor(
    protected element: ElementRef,
    private dialogReference: MatDialogRef<CheckoutErrorPanelComponent>,
  ) {
    super(element, true);
  }

  public dispose(event: Event) {
    super.close(this.dialogReference, null);
    event.preventDefault();
  }
}
